module.exports = __webpack_public_path__ + "static/media/Group.fd895861.png";